const config = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    clientUrl: process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000',
    stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL,
    clientUrl: process.env.REACT_APP_CLIENT_URL,
    stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY
  }
};

const environment = process.env.NODE_ENV || 'development';
const activeConfig = config[environment] || config.development;

export default {
  ...activeConfig,
  API_URL: `${(activeConfig.apiUrl || '').replace(/\/$/, '')}/api`,
  clientPort: process.env.REACT_APP_CLIENT_PORT || 3000
};
